module.exports = require('./toPairs');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/entries.js
// module id = 895
// module chunks = 0